"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function useControlledState(_a) {
    var value = _a.value, onChange = _a.onChange, defaultValue = _a.defaultValue;
    var _b = react_1.useState(defaultValue), internalValue = _b[0], onChangeInternal = _b[1];
    var handleChange = react_1.useCallback(function (nextValue) {
        onChangeInternal(nextValue);
        onChange === null || onChange === void 0 ? void 0 : onChange(nextValue);
    }, [onChangeInternal, onChange]);
    return [
        value !== null && value !== void 0 ? value : internalValue,
        handleChange,
    ];
}
exports.default = useControlledState;
